'use strict';

namespace Core {

    class StarRating {
        rating: number;
        stars: string[];

        constructor (
            private $scope: ng.IScope
        ) {
            this.$scope.$watch('sr.rating', (val) => {
                // create array of icon class names to iterate
                this.stars = _.map(new Array(this.rating), (v, idx) => {
                        return 'icon-star';
                    }
                );
            });
        }
    }

    angular
        .module('core')
        .directive('starRating', (): ng.IDirective => {

            return {
                scope: {},
                controller: StarRating,
                controllerAs: 'sr',
                bindToController: {
                    rating: '='
                },
                template: `<span class="star-rating">
                                <i class="{{r}}" ng-repeat="r in sr.stars track by $index"></i>
                            </span>`,
                replace: true
            };

        });

}
